import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import * as ProgressBar from "progressbar.js"
import * as misc from "./utils/misc";
import {logger} from "./utils/Log";
//import {BchdRest} from "./bitcoin-cash/BchdRest";
import {PaymentResponse} from "./structs/PaymentResponse";
import {PromptRest} from "./bitcoin-cash/PromptRest";


export class Pay extends AbstractPage {
    protected progressBarTimerID: number = 0;
    protected remainingPaymentTimeSec: number = 0;
    protected confirmationBarTimerID: number = 0;
    protected lastConfirmationCount: number = 0;
    protected confirmationExpectation: number = 0;

    protected receivedAmount: number = 0.0;
    //protected checkServerPaymentTimerID: number = 0; // timer calling web server // TODO needed?
    protected checkLocalPaymentTimerID: number = 0;
    protected askBackendTimerID: number = 0;
    protected fullyPaid: boolean = false;
    protected confirming: boolean = false;
    protected retryCount: number = 0;
    protected payment: PaymentResponse = null; // the latest payment status from API
    protected bchd: PromptRest;

    constructor(app: JqueryApp) {
        super(app);

        const config = this.app.getConfig();
        //this.bchd = new PromptRest(this.app.getConfig().bchdRestAddress);
        this.bchd = new PromptRest(this.app.getConfig().apiBase + "/node-api")

        this.app.$(window).on("load", ($) => {
            //this.addButtonLinkClass();
            if (this.app.$(".pay-preloader").length > 0) {
                this.app.$(".pay-preloader").fadeOut("slow");
            }
            this.webHelpers.preloadImages(config.payment.successPayImage, config.payment.successPayImageFinal);
        });
        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.addEventListeners();
            this.startPaymentTimer();
            //const msg = new AppMessage("fooo msg test", "danger");
            //msg.display()

            /*
            setTimeout(() => {
                this.sendPaidFrameMessage(); // TODO debug code to show frame immediately as paid
            }, 500);*/
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected addEventListeners() {
        if (this.app.$("#pay-qrcode-form").length !== 0)
            this.addPaymentFormEvents(this.app.$("#pay-qrcode-form").eq(0)); // the form after the order has been placed
    }

    protected addPaymentFormEvents(paymentFormEl: JQuery) {
        //const txid = paymentFormEl.find("#slp-txid-db").val();

        this.app.$(".pay-copy-field").click((event) => {
            event.preventDefault();
            const inputEl = this.app.$(event.target).parent().parent().find("input[type='text']");
            //let text = inputEl.val();
            inputEl.select();
            try {
                window.document.execCommand("copy");
            }
            catch (err) { // try-catch shouldn't be needed except for some really old browsers
            }
            inputEl.select(); // ensure it's selected again for iOS devices to copy it manually. not working, remove?
        });
        this.app.$("#pay-qrcode-form input[type='text']").click((event) => {
            this.app.$(event.target).select();
        });
        if (this.webHelpers.isAppleIOS() === true) // copy to clipboard button doesn't work there
            this.app.$("#pay-qrcode-form .slp-copy-field").addClass("hidden");
    }

    protected startPaymentTimer() {
        this.remainingPaymentTimeSec = this.app.getConfig().payment.timeRemainingSec;
        const startTimeSec = Math.floor(Date.now() / 1000); // ensure we keep track of real time cause setTimeout() gets delayed in background
        setTimeout(this.checkPaymentStatusLocally.bind(this, true), this.app.getConfig().payment.checkMs);
        if (this.remainingPaymentTimeSec <= 0) {
            this.setTimedOut();
            return;
        }

        const bar = new ProgressBar.Circle("#payment-timeout-bar", {
            strokeWidth: 6,
            easing: 'easeInOut',
            duration: 1400,
            color: '#1ab394',
            trailColor: '#eee',
            trailWidth: 1,
            svgStyle: null,
            text: {
                value: misc.toDisplayTimeHHMMSS(this.remainingPaymentTimeSec),
                style: {
                    position: 'absolute',
                    left: '50%',
                    top: '60%',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    }
                }
            }
        });
        bar.animate(this.getRemainingTimePercent());  // Number from 0.0 to 1.0

        this.progressBarTimerID = window.setInterval(() => {
            //this.remainingPaymentTimeSec--;
            this.remainingPaymentTimeSec = this.app.getConfig().payment.timeRemainingSec - (Math.floor(Date.now() / 1000) - startTimeSec);
            if (this.remainingPaymentTimeSec < 0)
                this.remainingPaymentTimeSec = 0;
            const remaining = this.getRemainingTimePercent();
            if (remaining <= 0.0) {
                clearInterval(this.progressBarTimerID);
                this.progressBarTimerID = 0;
                this.setTimedOut();
                return;
            }
            bar.animate(remaining, {
                duration: 800
            });
            bar.setText(misc.toDisplayTimeHHMMSS(this.remainingPaymentTimeSec));
        }, 1000);
    }

    protected getRemainingTimePercent() {
        const config = this.app.getConfig();
        let remaining = this.remainingPaymentTimeSec / config.payment.timeTotalSec;
        if (remaining < 0.0)
            remaining = 0.0;
        else if (remaining > 1.0)
            remaining = 1.0;
        return remaining;
    }

    protected getRemainingConfirmationsPercent() {
        const config = this.app.getConfig();
        const refreshTime = 1000;
        if (!this.payment)
            return 0.0;
        if (this.payment.confirmations_required == 0)
            return 1.0;
        if (this.lastConfirmationCount != this.payment.confirmations) {
            this.lastConfirmationCount = this.payment.confirmations;
            this.confirmationExpectation = 0;
        }
        let remaining = 1.0 - (this.payment.confirmations_required - this.payment.confirmations) / this.payment.confirmations_required;
        let range = (1.0 / this.payment.confirmations_required) * 0.90; // auto fill on timer up to 90% of the pending range
        let rangeStep = (config.payment.blockTime ? 1/(config.payment.blockTime/refreshTime) : 0.01); // percentage of the range to step per tick
        this.confirmationExpectation += range * rangeStep;
        if (this.confirmationExpectation > range) {
            this.confirmationExpectation = range
        }
        remaining += this.confirmationExpectation;
        if (remaining < 0.0)
            remaining = 0.0;
        else if (remaining > 1.0)
            remaining = 1.0;
        return remaining;
    }

    protected setTimedOut() {
        if (this.fullyPaid === true)
            return;
        const config = this.app.getConfig();
        if (config.payment.status == "CONFIRMING")
            return;
        logger.info("Payment has timed out");
        // TODO ask for email (if not provided already)
        this.app.$("#pay-pending").fadeOut("slow");
        this.app.$("#pay-expired").fadeIn("slow");
    }

    protected checkPaymentStatusLocally(repeat = true) {
        //this.askBackendForPayment(); // <<<< for testing only

        // check if the frame has been removed & stop querying
        const config = this.app.getConfig();
        if (config.fullPage === false) {
            // iframe code stops running if we call $.remove()
            //const $wnd = this.app.$(window);
            //if ($wnd.is(":visible") === false || $wnd.height() === 0) {
                //console.log(["Stopped querying for balance because payment controls have been removed", $wnd.is(":visible"), $wnd.height()]);
            /*
            if (window.top !== window.self) {
                console.log(["Stopped querying for balance because payment controls have been removed"]);
                return;
            }*/
        }
        if (config.payment.status == "CONFIRMING") {
            this.showPaymentConfirming(); // should already be done
            this.scheduleLocalPaymentStatusCheck(repeat, 5*this.app.getConfig().payment.checkMs);
            return;
        }
        if (config.payment.status == "PAID") {
            this.showPaymentReceived(); // should already be done
            this.webHelpers.log("Skipped querying for balance changes because fully paid");
            return;
        }

        //const tokenID = config.tokenID;
        const tokenID = config.payment.slp_token_id;
        const address = config.payment.address_slp ? config.payment.address_slp : config.payment.address;
        const isSlpPayment = address.indexOf("simpleledger") === 0; // starts with slp prefix

        let requestTokenID = isSlpPayment === true ? tokenID : "";
        clearTimeout(this.checkLocalPaymentTimerID);

        this.bchd.getAddressBalance(address, requestTokenID, true).then((balance) => {
            const previousAmount = this.receivedAmount;
            this.receivedAmount = balance;
            if (this.receivedAmount !== previousAmount) { // trigger a server-side re-check on balance change
                this.webHelpers.log("Noticed balance change. Asking Web Server...");
                /*
                clearTimeout(this.checkServerPaymentTimerID);
                this.checkServerPaymentTimerID = this.slpPayments.window.setTimeout(() => {
                    if (this.fullyPaid === false)
                        this.checkPaymentStatus(repeat, true, true); // will set it to fully paid
                }, this.slpPayments.getConfig().checkPaymentLocalIntervalSec * 1000);
                 */
                this.askBackendForPayment(); // query server to confirm
            }
            else if (repeat === false)
                return;
            this.scheduleLocalPaymentStatusCheck(repeat, this.app.getConfig().payment.checkMs);
        }).catch((err) => {
            this.webHelpers.log(err);
            // give it some more time before retry (internet connection might be down)
            this.scheduleLocalPaymentStatusCheck(repeat, 5*this.app.getConfig().payment.checkMs);
        });
    }

    protected scheduleLocalPaymentStatusCheck(repeat: boolean, timeoutMs: number) {
        clearTimeout(this.checkLocalPaymentTimerID); // ensure we don't run multiple timers
        this.checkLocalPaymentTimerID = window.setTimeout(() => {
            this.checkPaymentStatusLocally(repeat);
        }, timeoutMs);
    }

    protected askBackendForPayment() {
        if (this.askBackendTimerID !== 0 ) {
            clearTimeout(this.askBackendTimerID);
            this.askBackendTimerID = 0;
        }
        const url = /*window.location.protocol + window.location.host + */this.app.getConfig().pathPay + "/check";
        let params = {
            tx_id: this.app.getConfig().payment.id, // jQuery escapes if needed
        }
        this.webHelpers.getApi(url, params, (data) => {
            if (!data.payment) {
                logger.error("Invalid response on payment check %o", data);
                return;
            }
            this.payment = PaymentResponse.fromJson(data.payment);
            logger.verbose("payment update", this.payment);
            if (this.payment.status === "CONFIRMING") {
                //this.app.$("#pay-token-amount-remaining").text(this.payment.paid_amount_crypto);
                this.showPaymentConfirming();
            }
            else if (this.payment.status === "PAID")
                this.showPaymentReceived(); // otherwise we keep querying BCHD
            else if (this.payment.paid_amount_crypto > 0.0) {
                this.app.$("#pay-token-amount-remaining").text(this.payment.remaining_amount_crypto.toFixed(this.app.getConfig().numDecimals));
                this.app.$("#pay-remaining-txt").fadeIn("slow");

                // update QR Code
                // update payment amount in URI and QR code
                this.app.$("#pay-qr-code-image").attr("src", this.payment.qr_url);
                this.app.$("#pay-address").val(this.payment.payment_link);
                this.app.$("#pay-wallet").attr("href", this.payment.payment_link);
            }
            else if (this.retryCount < this.app.getConfig().payment.maxRetryCount) {
                this.retryCount++;
                logger.verbose("retry asking backend %d/%d times", this.retryCount, this.app.getConfig().payment.maxRetryCount);
                this.scheduleAskBackendForPayment();
            }
        });
    }

    protected scheduleAskBackendForPayment() {
        if (this.askBackendTimerID !== 0)
            return; // timer already running
        this.askBackendTimerID = window.setTimeout(() => {
            this.askBackendForPayment();
        }, this.app.getConfig().payment.checkMs);
    }

    protected showPaymentConfirming(){
        if (this.confirming === true)
            return; // already updated
        this.confirming = true;

        const config = this.app.getConfig();

        this.app.$("#block-explorer-link").fadeIn("slow");
        this.app.$("#pay-token-amount-remaining").text(config.payment.amount_crypto);

        config.payment.status = "CONFIRMING";
        //clearTimeout(this.checkServerPaymentTimerID);
        //clearTimeout(this.checkLocalPaymentTimerID);
        /*let successImage = window.document.createElement("img");
        successImage.src = config.payment.successPayImage;
        successImage.alt = config.payment.paidTxt;
        successImage.id = "pay-success-image-animated";
        this.addSuccessImageProperties(successImage);
        setTimeout(() => {
            this.showFinalPaidImage();
        }, 1300);*/

        const tr = this.app.getTr();

        // update confirmation count
        this.app.$("#pay-payment-status").text(tr.get("confirming"));

        this.app.$("#pay-payment-pending, #pay-payment-options, #pay-pay-instructions").fadeOut("slow");
        this.app.$("#pay-qr-code-image, #pay-qrcode-form, #pay-manual-payment, #pay-wallet, #payment-timeout-bar").fadeOut("slow");
        //this.app.$("#pay-qr-code").fadeOut("slow");
        //this.app.$("#pay-qr-code").replaceWith(successImage);

        const bar = new ProgressBar.Line("#payment-confirmation-bar", {
            strokeWidth: 6,
            easing: 'easeInOut',
            duration: 1400,
            color: '#1ab394',
            trailColor: '#eee',
            trailWidth: 1,
            svgStyle: null,
            text: {
                value: "",
                style: {
                    position: 'absolute',
                    left: '50%',
                    top: '60%',
                    color: '#343a40',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    }
                }
            }
        });
        bar.animate(this.getRemainingConfirmationsPercent());  // Number from 0.0 to 1.0

        this.confirmationBarTimerID = window.setInterval(() => {
            // update confirmation count. Don't always API this or we have MULTIPLE request piling up in case of slow server
            this.scheduleAskBackendForPayment();

            if (config.payment.status == "PAID") {
                this.showPaymentReceived(); // should already be done
                this.webHelpers.log("Skipped querying for balance changes because fully paid");
                return;
            }

            const remaining = this.getRemainingConfirmationsPercent();

            bar.animate(remaining, {
                duration: 800
            });
            if (this.payment)
                bar.setText(tr.get("confirmingShort") + tr.get("colon") + " " + this.payment.confirmations + "/" + this.payment.confirmations_required);
            else
                bar.setText("");

            if (remaining >= 1.0) {
                clearInterval(this.confirmationBarTimerID);
                this.confirmationBarTimerID = 0;
                return;
            }
        }, 1000);
    }

    protected showPaymentReceived() {
        if (this.fullyPaid === true)
            return; // already updated
        this.fullyPaid = true;
        // TODO does partial payment work?

        const config = this.app.getConfig();
        const tr = this.app.getTr();

        config.payment.status = "PAID";
        //clearTimeout(this.checkServerPaymentTimerID);
        clearTimeout(this.checkLocalPaymentTimerID);
        let successImage = window.document.createElement("img");
        successImage.src = config.payment.successPayImage;
        successImage.alt = tr.get("paid");
        successImage.id = "pay-success-image-animated";
        this.addSuccessImageProperties(successImage);
        setTimeout(() => {
            this.showFinalPaidImage();
        }, 1300);

        this.app.$("#pay-payment-status").text(tr.get("paid"));
        this.app.$("#pay-payment-pending, #pay-payment-options, #pay-pay-instructions").fadeOut("slow");
        this.app.$("#pay-qr-code").replaceWith(successImage);

        this.sendPaidFrameMessage();
    }

    protected sendPaidFrameMessage() {
        const config = this.app.getConfig();
        if (this.payment === null) {
            console.warn("Generating mock payment. This shouldn't happen in production!");
            this.payment = PaymentResponse.generateMockPayment(config.payment.id);
        }

        if (config.fullPage === true) {
            console.debug("Skipped sending 'paid' message in fullPage mode");
            return;
        }
        if (window.parent === window.self) {
            console.debug("Skipped sending 'paid' message without parent");
            return; // should be same as fullPage === true
        }
        let targetOrigin = config.ref || "*"; // send to all windows as fallback only
        //console.debug("Sending 'paid' message to origin: %s", targetOrigin);
        window.parent.postMessage({
            'func': 'onPromptPaid',
            'data': this.payment,
        }, targetOrigin);
    }

    protected showFinalPaidImage() {
        const config = this.app.getConfig();
        //let successImageFinal: HTMLImageElement = Object.assign(this.slpPayments.window.document.createElement("img"), successImage); // doesn't copy attributes of native elements
        let successImageFinal = window.document.createElement("img");
        successImageFinal.src = config.payment.successPayImageFinal;
        //successImageFinal.alt = this.slpPayments.getConfig().paidTxt;
        successImageFinal.id = "pay-success-image";
        this.addSuccessImageProperties(successImageFinal);
        this.app.$("#pay-success-image-animated, #pay-qr-code").replaceWith(successImageFinal);

        // redirect customer back to store
        logger.verbose("Returning customer to URL: %s", config.payment.returnUrl);
        if (!config.payment.returnUrl || config.payment.returnUrl.toLowerCase().indexOf("http") !== 0)
            return;
        window.location.replace(config.payment.returnUrl);
    }

    protected addSuccessImageProperties(image: HTMLImageElement) {
        image.style.maxWidth = "300px";
        image.style.maxHeight = "300px";
        image.style.width = "100%";
        image.style.display = "block";
        image.className = "pay-center";
    }
}
